import { render, staticRenderFns } from "./PenalidadesPedidoView.vue?vue&type=template&id=2a5c8bb4&scoped=true"
import script from "./PenalidadesPedidoView.vue?vue&type=script&lang=js"
export * from "./PenalidadesPedidoView.vue?vue&type=script&lang=js"
import style0 from "./PenalidadesPedidoView.vue?vue&type=style&index=0&id=2a5c8bb4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c8bb4",
  null
  
)

export default component.exports